import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IPbxUser } from 'voxloud-types/dist/models';
import { UserService } from '../../../services/user/user.service';
import { AccountFacade } from '../../../../account/store/facade';

@Component({
  selector: 'filter-users',
  templateUrl: './filter-users.component.html',
  styleUrls: ['./filter-users.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterUsersComponent),
      multi: true
    }
  ]
})
export class FilterUsersComponent implements ControlValueAccessor {

  public onChange: any = () => { };
  public onTouch: any = () => { };

  public users: IPbxUser[] = [];
  public selectedUser: IPbxUser;

  public loadingUsers: boolean = false;
  public apiError: boolean = false;

  constructor(
    private accountFacade: AccountFacade
  ) {}

  public ngOnInit() {
    this.accountFacade.pbx$.subscribe({
      next: (pbx) => {
        this.users = pbx['users'];
      }
    })
  }

  public changeUser(user: IPbxUser) {
    this.selectedUser = user;
    this.onChange(this.selectedUser.aggregate_id);
  }

  writeValue(obj: string): void {
    if (obj) {
      this.selectedUser = this.users.find(user => user.aggregate_id === obj) || this.users?.[0];
      this.onChange(this.selectedUser.aggregate_id);
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
}
